import React, {useState} from 'react';
import './../Styles/Home.scss';

import Mascot from './../Images/Mascot/mascot.png';
import MascotHermit from './../Images/Mascot/logo.gif';

import Arrow from './../Images/arrow.png';

import FacebookIcon from './../Images/Icons/Facebook.png'
import LinkedInIcon from './../Images/Icons/Linkedin.png'
import GithubIcon from './../Images/Icons/Github.png'
import ItchioIcon from './../Images/Icons/Itchio.png'


import ShardsFull from './../Images/about_shards.png';


import DeveloperIcon from './../Images/Icons/developer.png';
import ArtistIcon from './../Images/Icons/artist.png';
import EducationIcon from './../Images/Icons/education.png';

import PortfolioCard from './../Components/PortfolioCard'
import GalleryCard from './../Components/GalleryCard'

import Modal from './../Components/Modal'

interface HomeProps {
    // define your props here
  }
  
const Home: React.FC<HomeProps> = (props) => {
    const [showModal, setShowModal] = useState(false);

    const handleOpenModal = () => {
      setShowModal(true);
    };
  
    const handleCloseModal = () => {
      setShowModal(false);
    };

    return (
        <div>
            <div className="section__main">
                <div className="content">
                    <div className="text">
                        <div className="main">
                            <div className="socials">
                                <a href="https://www.facebook.com/chrystarinstudios" target="_blank" rel="noreferrer"> <img src={FacebookIcon} alt="facebook_icon"/></a>
                                <a href="https://www.linkedin.com/in/chrystarin/" target="_blank" rel="noreferrer"> <img src={LinkedInIcon} alt="linkedin_icon"/></a>
                                <a href="https://github.com/Chrystarin" target="_blank" rel="noreferrer"> <img src={GithubIcon} alt="github_icon"/></a>
                                <a href="https://chrystarin.itch.io/" target="_blank" rel="noreferrer"> <img src={ItchioIcon} alt="itchio_icon"/></a>
                            </div>
                            <div>
                                <h2>Hello! I am</h2> 
                                <h1>CHRYSTARIN</h1>
                                <h2>Developer and Artist</h2>
                                <h3 className="quote">"Doing my best everyday to become <br/> the better version of my yesterday"</h3>
                            </div>
                        </div>
                        
                        <div>
                            <a href="https://drive.google.com/file/d/1bmarMqoYyuykNy9eWhWFPRO3f6rBQURE/view?usp=sharing" target="_blank" rel="noreferrer">
                                <button className="download_cv">My Resume</button>
                            </a>
                        </div>
                    </div>

                    <div className="mascot">
                        <img src={Mascot} alt="Mascot"/>
                    </div>
                    <div className="arrow">
                        <img src={Arrow} alt="arrow"/>
                    </div>
                    
                    
                </div>
            </div>
            <div className="section__about">
                <div className="content">
                    {/* <div className="shards-full">
                        <img src={ShardsFull} alt="ShardsFull"/>
                    </div> */}
                    <div className="image">
                        <img src={MascotHermit} alt="MascotHermit"/>
                    </div>
                    <div className="text">
                        <h1>About Me</h1>
                        <p>
                            An achiever and problem solver with a consistent daily desire to unlock new knowledge, skills, and experiences. I am a passionate creator 
                            specializing in developing mobile apps, web apps, and games along with creative arts such as 2D/3D illustration and animation.
                        </p>
                    </div>

                </div>
            </div>
            <div className="divider">
            </div>
            {/* <div className="section__about__more">
                <div className="content">
                    <div className="column">
                        <img src={DeveloperIcon} alt="DeveloperIcon"/>
                        <h2>Developer</h2>
                        <ul>
                            <li>Develop web applications through using frameworks such as React, Express, Node, Laravel, and Mongoose.</li>
                            <li>Develop game applications using Unity, Renpy, and RPG Maker MV.</li>
                            <li>Develop mobile applications using Android Studio.</li>
                        </ul>
                    </div>
                    <div className="column">
                        <img src={ArtistIcon} alt="ArtistIcon"/>
                        <h2>Artist</h2>
                        <ul>
                            <li>Create 2D digital artworks such as character sprites, backgrounds, and CGI.</li>
                            <li>Artist of several content creators, streamers and indie game developers.</li>
                            <li>Solid experience as a graphic artist since 2016 until 2022 through part-time and freelancing.</li>
                        </ul>
                    </div>
                    <div className="column">
                        <img src={EducationIcon} alt="EducationIcon"/>
                        <h2>Education</h2>
                        <ul>
                            <li>Currently taking Bachelor of Science Major in Computer Science in STI College Marikina.</li>
                            <li>Took on various leadership roles such as President of IT Club and ICT Society SR, and Secretary of TechieSH.</li>
                            <li>Earned various recognitions and awards (See CV for info)</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="section__portfolio">
                <div className="content">
                    <h1>My Portfolio</h1>
                    <p>The following is a collection of the projects I have worked on.</p>
                    <div className="container">
                        <PortfolioCard
                            title={"Project 1"}
                            subtitle={"I am a project 1"}
                            image={MascotHermit}
                            link={"#"}
                        />
                        <PortfolioCard
                            title={"Project 2"}
                            subtitle={"I am a project 2"}
                            image={Mascot}
                            link={"#"}
                        />
                        <PortfolioCard
                            title={"Project 3"}
                            subtitle={"I am a project 3"}
                            image={MascotHermit}
                            link={"#"}
                        />
                    </div>
                </div>
            </div>
            <div className="section__gallery">
                <div className="content">
                    <h1>My Gallery</h1>
                    <p>The following is a collection of my artworks I have made.</p>
                    <div className="container">
                        <GalleryCard
                            title={"Artwork 1"}
                            image={MascotHermit}
                            action={handleOpenModal}
                        />
                        <GalleryCard
                            title={"Artwork 2"}
                            image={Mascot}
                            action={handleOpenModal}
                        />
                        <GalleryCard
                            title={"Artwork 3"}
                            image={MascotHermit}
                            action={handleOpenModal}
                        />
                    </div>
                    
                </div>
            </div> */}
            {showModal && (
                <Modal imageUrl={Mascot} onClose={handleCloseModal} />
            )}
        </div>
    );
};

export default Home;